import styled from "styled-components";

export const Section = styled.section`
  padding: ${({ theme }) => theme.spacing[48]} 0;
`;
